import ModernTrafficLight from "./TrafficLight/ModernTraficLight"

const ModernTrafficLightApp = () => {
    return <ModernTrafficLight size={80} />
}

export default ModernTrafficLightApp
